/**
 * @file api-shop-pickup.ts
 * @description Пункт самовывоза магазина (phase19.24 шаг 5.1).
 *
 * Зеркалит `GET /admin/shops/current/pickup-location` → адрес, график и
 * телефон склада магазина. Источник тот же, что у витрины
 * (`resolveShopPickupLocation`): менеджер и клиент обязаны видеть один адрес,
 * иначе письмо зовёт человека не туда.
 *
 * Пункт может быть не заполнен — сервер отдаёт `null`, и это НЕ ошибка:
 * форма показывает предупреждение со ссылкой в настройки складов, а черновик
 * заказа создать всё равно можно.
 */

import { apiFetch } from "./api-client";

/** Пункт самовывоза: что напишем клиенту в письме и на странице заказа. */
export interface ShopPickupLocationDto {
  /** Название точки («Основной склад»); пустая строка — склад не заведён. */
  name: string;
  /** Адрес одной строкой; ПУСТАЯ СТРОКА — у склада адреса нет (сервер не шлёт null). */
  address: string;
  phone: string;
  /** График: «Пн–Пт 10–19, Сб 11–16»; пустая строка — уточнит менеджер. */
  workingHours: string;
}

/** Пункт самовывоза магазина; `null` — склад не настроен. */
export function getShopPickupLocation(): Promise<ShopPickupLocationDto | null> {
  return apiFetch<ShopPickupLocationDto | null>("/admin/shops/current/pickup-location");
}

/**
 * Готов ли пункт к отправке письма: без адреса клиент не узнает, куда ехать.
 * Название и график можно дозаполнить позже — они не блокируют отправку.
 */
export function isPickupLocationReady(
  location: ShopPickupLocationDto | null,
): location is ShopPickupLocationDto {
  return !!location && !!location.address && location.address.trim().length > 0;
}
